import { render, staticRenderFns } from "./AddStockData.vue?vue&type=template&id=6ae6bdcd&scoped=true"
import script from "./AddStockData.vue?vue&type=script&lang=js"
export * from "./AddStockData.vue?vue&type=script&lang=js"
import style0 from "./AddStockData.vue?vue&type=style&index=0&id=6ae6bdcd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae6bdcd",
  null
  
)

export default component.exports